import React, { useState } from 'react';
import { FiLayers, FiAlertTriangle, FiSettings } from 'react-icons/fi';
import ModalPerfis from './ModalPerfis';
import CampoCodigoMunicipal from '../CampoCodigoMunicipal';
import styles from './Emitir.module.css';
import EventoServico, { exigeEvento } from './EventoServico';

/* Etapa 2 — Serviço.
   Os códigos fiscais (CTN, NBS, operação, município, alíquota) vêm todos do
   perfil de tributação cadastrado no cliente, então aparecem aqui só pra
   conferência, não como campos editáveis -- eram 5 campos que ninguém
   digitava, porque a resposta já estava no cadastro.

   A descrição continua editável: é a única parte que muda de nota pra nota. */

const ROTULO_TRIBUTACAO = {
  1: 'Operação tributável',
  2: 'Exportação de serviço',
  3: 'Não incidência',
  4: 'Imunidade',
};

function Codigo({ rotulo, valor, alerta }) {
  return (
    <div className={styles.codigoItem}>
      <span className={styles.codigoRotulo}>{rotulo}</span>
      <span className={alerta && !valor ? styles.codigoFaltando : styles.codigoValor}>
        {valor || (alerta ? 'não definido' : '—')}
      </span>
    </div>
  );
}

function EtapaServico({ dados, set, perfis, perfilId, onTrocarPerfil, municipioPrestacaoNome, onAbrirCadastro, clienteId, corpo }) {
  const [modalAberto, setModalAberto] = useState(false);
  const perfilAtivo = perfis.find(p => p.id === perfilId);
  /* complemento municipal definido no perfil é fixo: aparece só como
     leitura. O campo de escolha fica pra quando o perfil não tem e o código
     foi trocado na nota. */
  const complementoDoPerfil = !!perfilAtivo?.codigo_tributacao_municipal
    && perfilAtivo.codigo_tributacao_municipal === dados.codigoTributacaoMunicipal
    && perfilAtivo.codigo_tributacao_nacional === dados.codigoTributacaoNacional;
  /* vencimento é raro: só aparece se veio preenchido (fornecedor/perfil),
     se o fornecedor manda informar, ou se a pessoa pedir */
  const [vencimentoAberto, setVencimentoAberto] = useState(false);
  const mostrarVencimento = !!dados.vencimento || !!dados.vencimentoInformar || vencimentoAberto;

  return (
    <div className={styles.etapa}>
      <section className={styles.secao}>
        <div className={styles.tomadorCabecalho}>
          {/* só aparece quando há mais de um perfil: com um só, escolher
              seria um clique sem alternativa */}
          {perfis.length > 1 && (
            <button type="button" className={styles.btnSelecionarIcone}
              onClick={() => setModalAberto(true)} title="Trocar perfil de tributação">
              <FiLayers size={14} />
            </button>
          )}
          <h3 className={styles.secaoTitulo} style={{ margin: 0 }}>
            Serviço prestado
            {perfilAtivo && <span className={styles.perfilEtiqueta}>{perfilAtivo.nome}</span>}
          </h3>
        </div>

        {perfis.length === 0 ? (
          <div className={styles.aviso}>
            <FiAlertTriangle size={14} />
            <div style={{ flex: 1 }}>
              Este cliente não tem perfil de tributação cadastrado — é dele que saem os
              códigos da nota (CTN, NBS, município, alíquota).
              {onAbrirCadastro && (
              <button type="button" className={styles.btnCorrigir} onClick={onAbrirCadastro}>
                <FiSettings size={12} /> Cadastrar perfil
              </button>
              )}
            </div>
          </div>
        ) : (
          <div className={styles.codigosGrade}>
            <Codigo rotulo="Cód. Tributação Nacional" valor={dados.codigoTributacaoNacional} alerta />
            {complementoDoPerfil && <Codigo rotulo="Cód. complementar municipal" valor={dados.codigoTributacaoMunicipal} />}
            <Codigo rotulo="Local da prestação" valor={municipioPrestacaoNome} alerta />
            <Codigo rotulo="Código NBS" valor={dados.itemNbs} />
            <Codigo rotulo="Cód. da operação" valor={dados.codigoOperacao} />
            <Codigo rotulo="Alíquota ISS"
              valor={dados.aliquotaIss === '' || dados.aliquotaIss == null ? 'apurado pelo Simples' : `${dados.aliquotaIss}%`} />
            <Codigo rotulo="Tributação do ISSQN" valor={ROTULO_TRIBUTACAO[dados.tributacaoIssqn]} />
          </div>
        )}

        {/* complemento municipal: depende do município, então é consultado aqui */}
        {dados.codigoTributacaoNacional && !complementoDoPerfil && (
          <div className={styles.campo} style={{ marginTop: 14 }}>
            <span className={styles.rotulo}>Código complementar municipal{dados.cTribMunExige ? ' *' : ''}</span>
            <CampoCodigoMunicipal clienteId={clienteId} className={styles.entrada}
              ctn={dados.codigoTributacaoNacional} municipio={dados.codigoMunicipioPrestacao}
              valor={dados.codigoTributacaoMunicipal} onChange={v => set('codigoTributacaoMunicipal', v)}
              onInfo={(i) => set('cTribMunExige', !!i.exige)} />
          </div>
        )}

        {exigeEvento(dados.codigoTributacaoNacional) && <EventoServico dados={dados} set={set} />}

        {/* cobrança: vencimento pela regra do perfil, editável nesta nota */}
        {mostrarVencimento ? (
          <div className={styles.campo} style={{ marginTop: 14 }}>
            <span className={styles.rotulo}>Vencimento da cobrança</span>
            <input type="date" className={styles.entrada} value={dados.vencimento || ''} onChange={e => set('vencimento', e.target.value)} style={{ maxWidth: 200 }} />
          </div>
        ) : (
          <button type="button" className={styles.btnSecundario} style={{ marginTop: 14 }}
            onClick={() => setVencimentoAberto(true)}>+ Vencimento da cobrança</button>
        )}

        {/* único campo que muda de nota pra nota */}
        <div className={styles.campo} style={{ marginTop: 14 }}>
          <span className={styles.rotulo}>Descrição do serviço *</span>
          <textarea className={styles.entrada} rows={3} maxLength={2000}
            value={dados.descricaoServico}
            onChange={e => set('descricaoServico', e.target.value)}
            placeholder="O que foi prestado nesta nota..." />
          <span className={styles.dica}>{(dados.descricaoServico || '').length} / 2000</span>
        </div>
      </section>

      {modalAberto && (
        <ModalPerfis
          perfis={perfis}
          perfilId={perfilId}
          onFechar={() => setModalAberto(false)}
          onSelecionar={(p) => { onTrocarPerfil(p.id); setModalAberto(false); }}
        />
      )}
    </div>
  );
}

export default EtapaServico;
